import React, { useEffect, useRef, useState } from 'react';
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import edit from "../../../../assets/images/edit.png";
import Planing from "../../../../assets/images/planning.png";
import Trash from "../../../../assets/images/trash.png";
import Info from "../../../../assets/images/info.png";
import Box from "../../../../assets/images/box.png";
import RedCross from "../../../../assets/images/close.png";
import TrashRed from "../../../../assets/images/trash_red.png";
import CargoTruck from "../../../../assets/images/cargo-truck.png";
import BlueFlight from "../../../../assets/images/blueFlight.jpg";
import blue_flight from "../../../../assets/images/plane.svg";
import ActivityComments from '../../../../Components/common/ActivityComments.js';
import ImageUpload from '../../../../Components/common/ImageUpload.js';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import AddAWB from '../AWBMonitor/Components/AddAWB.js';
import AssignAWB from '../AWBMonitor/Components/AssignAWB.js';
import Loader from '../../../../Components/common/Loader.js';


import { faArrowLeft, faBolt, faChevronDown, faGear, faPaperclip, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { withRFSToken } from '../../../../Services/axios.js';
import { BOOKINGTRUCKDETAILS, DELAWB, ADDAWB, TRUCKORDERDETAILS } from '../../../../Utils/conts';
import { toast } from 'react-toastify';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
const Details = () => {
    const fileInputRef = useRef(null);
    let storedData = localStorage.getItem('BTDetails');
    if (storedData) {
        storedData = JSON.parse(storedData)
    }
    const [selectedRowData, setSelectedRowData] = useState();
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridSelect, setGridSelect] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [availableScheduleTruck, setAvailableScheduleTruck] = useState();
    const [allData, setAlldata] = useState();
    const gridRef = useRef(null);
    const [notArea, setNotArea] = useState();
    const [rowId, setRowId] = useState();
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState();
    const [show, setShow] = useState(false);
    const [reAssignShow, setReAssignShow] = useState(false);
    const [addEdit, setAddEdit] = useState('');
    const [editmodalData, setEditModalData] = useState();
    const [gridSelectData, setGridSelectData] = useState();
    const [selectedTrucks, setSelectedTrucks] = useState({
        bookingtruck_date_id: '',
        departure_date: ''
    });
    const [confirmModal, setConfirmModal] = useState(false);

    const loadDetails = async (number, dateid) => {
        try {
            const res = await withRFSToken.post(BOOKINGTRUCKDETAILS, { bookingtruck_id: number, bookingtruck_date_id: dateid, })
                .then(function (res) {
                    const innerData = res;
                    console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code == 200) {
                        setSelectedRowData(res.data.response_data);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    const getAvailableScheduleTruck = async () => {
        try {
            const res = await withRFSToken.post('get-available-schedule-trucks', { bookingtruck_id: storedData.bookingtruck_id, bookingtruck_date_id: storedData.bookingtruck_date_id })
                .then(function (res) {
                    const innerData = res;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code == 200) {
                        setAvailableScheduleTruck(res.data.response_data);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    const orderTruckRedirect = () => {
        // setShow(true);
        const checkOT = localStorage.getItem('OT');
        if (checkOT) {
            localStorage.removeItem('OT');
        }
        localStorage.removeItem('TD');
        localStorage.setItem('TD', JSON.stringify(selectedRowData));
        window.location.href = '/OrderTruck';
    }

    // const handleBrowseFiles = (e) => {
    //     e.preventDefault();
    //     fileInputRef.current.click();
    // };

    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData([]);
        loadDetails(storedData.bookingtruck_id, storedData.bookingtruck_date_id);
        isMounted.current = true;
    }, []);
    const [loaderModal, setLoaderModal] = useState(false);

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const btid = storedData?.bookingtruck_date_id
            const ttrid = storedData?.bookingtruck_id
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}get-assigned-awbs?bookingtruck_date_id=${btid}&bookingtruck_id=${ttrid}`,
                beforeSend: function (jqXHR) {
                    setLoaderModal(true);
                    // jqXHR.setRequestHeader('Authorization', token);
                },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'awb_id', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'time', type: 'string' },
                    { name: 'flight_number_join', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                    { name: 'truck_no', type: 'string' },
                    { name: 'truck', type: 'string' },
                    { name: 'received', type: 'string' },
                    { name: 'pieces', type: 'string' },
                    { name: 'weight', type: 'string' },
                    { name: 'volume', type: 'string' },
                    { name: 'shc', type: 'string' },
                    { name: 'commodity', type: 'string' },
                    { name: 'connection_time', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'rcs_total_pieces_awb', type: 'string' },
                    { name: 'bkd', type: 'string' },
                    { name: 'colour_status', type: 'string' },
                    { name: 'movements', type: 'string' },
                    { name: 'differtime', type: 'string' },
                    { name: 'import_export', type: 'string' },
                    { name: 'connection_flight', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'uld_contour', type: 'string' },
                    { name: 'uld_loadtype', type: 'string' },
                ],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    setLoaderModal(false);
                    source.totalrecords = data.TotalRows;
                    setAlldata(data);
                },
                sort: function (column, direction) {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns;
            columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /> <img src="' + Info + '" class="row_info" /></div>';
                    },
                    width: '7%', filterable: false,
                },
                {
                    text: 'Airway bill', filtertype: 'textbox', datafield: 'airway_bill', width: '12%', cellclassname: '',
                    cellclassname: (row, column, value, rowData) => {
                        if (rowData.colour_status == 'G') {
                            return "awb_green";
                        } else if (rowData.colour_status == 'R') {
                            return "awb_red";
                        } else if (rowData.colour_status == 'O') {
                            return "awb_orange";
                        } else {
                            return;
                        }
                    },
                },
                // { text: 'Import / Export', filtertype: 'textbox', datafield: 'import_export', width: '8%', cellclassname: '', },
                { text: 'Connected Flight', filtertype: 'textbox', datafield: 'connection_flight', width: '10%', cellclassname: '', },
                { text: 'CT', filtertype: 'textbox', datafield: 'connection_time', width: '5%', cellclassname: '', },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '5%', cellclassname: '', },
                { text: 'Dest.', filtertype: 'textbox', datafield: 'destination', width: '5%', cellclassname: '', },
                 { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '11%', cellclassname: '', },
                  { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', },
                { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '6%', cellclassname: '', },
                { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '5%', cellclassname: '', },
                { text: 'ULD No', filtertype: 'textbox', datafield: 'uld_number', width: '8%', cellclassname: '', },
                { text: 'ULD Contour', filtertype: 'textbox', datafield: 'uld_contour', width: '9%', cellclassname: '', },
                { text: 'ULD Load Type', filtertype: 'textbox', datafield: 'uld_loadtype', width: '10%', cellclassname: '', }, 
                // {
                //     text: 'RCS / DEP',
                //     width: '7%',
                //     filterable: false,
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowData) {
                //         const pieces = parseFloat(rowData.pieces) || 0;
                //         const rcs = parseFloat(rowData.rcs_total_pieces_awb) || 0;
                //         let displayValue = `<div class="" style="margin-top: 13.5px;"><img src='${RedCross}' alt='Not Received' title='Not Received' /></div>`;
                //         if (rcs > 0) {
                //             displayValue = `${rcs} / ${pieces}`;
                //         }
                //         return `<div class="" style="margin-top: 13.5px;">${displayValue}</div>`;
                //     },
                // },
                // { text: 'Flight', filtertype: 'textbox', datafield: 'flight_number_join', width: '9%', cellclassname: '', },
               
               
                // {
                //     text: 'Truck',
                //     datafield: 'truck_no',
                //     filtertype: 'textbox',
                //     width: '9%',
                //     cellclassname: '',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         // if truck_no is empty, null, or undefined, fallback to rowdata.truck
                //         const displayValue = value && value.trim() !== '' ? value : (rowdata.truck || '');
                //         return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;">${displayValue}</div>`;
                //     }
                // }
                // { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '11%', cellclassname: '', },

            ];
            const nestedColumns = [
                { text: 'Pieces', datafield: 'pieces', width: '14%' },
                { text: 'Weight', datafield: 'weight', width: '14%' },
                { text: 'Length', datafield: 'length', width: '14%' },
                { text: 'Width', datafield: 'width', width: '14%' },
                { text: 'Height', datafield: 'height', width: '14%' },
                { text: 'Stackable', datafield: 'stackable', width: '14%' },
                { text: 'Rotatable', datafield: 'rotatable', width: '14%' },
            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;
                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        event.stopPropagation();
                    }
                });
                const id = record.uid.toString();
                const uldGrid = Array.isArray(record.package_information)
                    ? record.package_information
                    : (record.package_information ? [record.package_information] : []);
                const nestedSource = {
                    datatype: 'array',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'pieces', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'length', type: 'string' },
                        { name: 'width', type: 'string' },
                        { name: 'height', type: 'string' },
                        { name: 'stackable', type: 'string' },
                        { name: 'rotatable', type: 'string' },
                    ],
                    localdata: uldGrid,
                }
                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
                const nestedGridOptions = {
                    width: '90%',
                    pageable: false,
                    sortable: false,
                    autoheight: true,
                    height: (10 * 45),
                    selectionmode: 'none',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i;
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            attachDelegatedTooltipHandlers();
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awb_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.awb_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awb_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awb_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awb_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                // const dataToSend = {
                //     uld_number: rowData.uld_number,
                //     type_code: rowData.type_code,
                //     serial_number: rowData.serial_number,
                //     owner_code: rowData.owner_code,
                //     condition_code: rowData.condition_code,
                //     asset_type: rowData.asset_type
                // };
                handleShow('E', rowData);
                // setEditData(dataToSend);
                setShowEdit(true);
            });
            window.$(gridRef.current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                handleModalOpen('G', rowData.awb_id);
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    // loadDetails(args.uld_number);
                }
            });
        }
    }, [gridData]);

    let $customTooltip = null;

    function ensureTooltipDiv() {
        if (!$customTooltip) {
            $customTooltip = window.$('<div id="custom-awb-tooltip" />').css({
                position: 'absolute',
                'z-index': 999999,
                display: 'none',
                'max-width': '480px',
                'overflow-y': 'auto',
                'overflow-x': 'hidden',
                'max-height': '50vh',
            }).appendTo('body');
        }
    }
    function formatTime(timeStr) {
        console.log("🚀 ~ formatTime ~ timeStr:", timeStr)
        if (!timeStr) return '';
        const parts = timeStr.split(':');
        if (parts.length >= 2) {
            const hours = parts[0].padStart(2, '0');
            const minutes = parts[1].padStart(2, '0');
            return `${hours}:${minutes}`;
        }
        return timeStr;
    }
    function buildTooltipHtml(data) {
        if (!data) return '<div>No data</div>';
        let htmlContent = '';
        const movements = Array.isArray(data.movements) ? data.movements : (data.movements ? [data.movements] : []);
        const differtime = Array.isArray(data.differtime) ? data.differtime : (data.differtime ? [data.differtime] : []);
        if (movements.length > 0) {
            if (Array.isArray(movements)) {

                let departureDate = null;
                let departureTime = null;
                let previousArrival = null;
                movements.forEach(element => {
                    let imageFile = null;
                    let Boardpoint = '';
                    let Offpoint = '';
                    let allDateTime = null;
                    let connectionTime = null;
                    let connectionDetailsTime = null;
                    if (element.type === 'Flight') {
                        let arrivalDateTime = element.flight_schedule?.arrival_date_utc ?? null;
                        let departureDateTime = element.flight_schedule?.departure_date_utc ?? null;

                        let arrivalDate = arrivalDateTime ? arrivalDateTime.split(' ')[0] : null;
                        let arrivalTime = arrivalDateTime ? arrivalDateTime.split(' ')[1] : null;
                        let depDate = departureDateTime ? departureDateTime.split(' ')[0] : null;
                        let depTime = departureDateTime ? departureDateTime.split(' ')[1] : null;
                        if (previousArrival && depDate && depTime) {
                            let prev = new Date(previousArrival);
                            let curr = new Date(`${depDate}T${depTime}`);
                            let diffMinutes = (curr - prev) / (1000 * 60); // in minutes
                            if (diffMinutes >= 0) connectionTime = formatMinutesToHHMM(diffMinutes);
                            connectionTime = (diffMinutes >= 0 ? '' : '-') + formatMinutesToHHMM(Math.abs(diffMinutes));
                            connectionDetailsTime = (diffMinutes >= 0 ? '' : '-') + "Prev-" + previousArrival + "<br/>Curr" + `${depDate}T${depTime}`;
                        }
                        imageFile = BlueFlight;
                        Boardpoint = element.flight_schedule?.origin;
                        Offpoint = element.flight_schedule?.destination;
                        allDateTime = element.flight_schedule;
                        previousArrival = arrivalDateTime ? `${arrivalDate}T${arrivalTime}` : null;
                        departureDate = depDate;
                        departureTime = depTime;
                    }
                    else if (element.type === 'Truck') {
                        let arrivalDate = element.booking_truck_date_detail?.arrival_date;
                        let arrivalTime = element.booking_truck_date_detail?.arrival_time;
                        let depDate = element.booking_truck_date_detail?.departure_date;
                        let depTime = element.booking_truck_date_detail?.departure_time;
                        if (previousArrival && depDate && depTime) {
                            let prev = new Date(previousArrival);
                            let curr = new Date(`${depDate}T${depTime}`);
                            let diffMinutes = (curr - prev) / (1000 * 60);
                            connectionTime = (diffMinutes >= 0 ? '' : '-') + formatMinutesToHHMM(Math.abs(diffMinutes));
                            connectionDetailsTime = (diffMinutes >= 0 ? '' : '-') + "Prev-" + previousArrival + "<br/>Curr" + `${depDate}T${depTime}`;
                        }
                        imageFile = CargoTruck;
                        Boardpoint = element.booking_truck_date_detail?.booking_truck_details?.board_point_station?.station_code;
                        Offpoint = element.booking_truck_date_detail?.booking_truck_details?.off_point_station?.station_code || '';
                        allDateTime = element.booking_truck_date_detail;
                        previousArrival = arrivalDate && arrivalTime ? `${arrivalDate}T${arrivalTime}` : null;
                        departureDate = depDate;
                        departureTime = depTime;
                    }
                    let className = "";
                    if (connectionTime) {
                        const [hours, minutes] = connectionTime.split(':').map(Number);
                        if (hours < 10) {
                            className = "error_connection_tym";
                        } else {
                            className = "success_connection_tym";
                        }
                        htmlContent += `<div class='${className} d-flex justify-content-between'><span>Connection Time -</span>
                                                <span>${connectionTime}</span></div><p class="d-none">${connectionDetailsTime}</p>`;
                    }
                    htmlContent += `
                        <div class='route_segment_list'>
                            <h6>${element.flight_truck_no} / ${element.date}</h6>
                            <div class='Boardpoint_offpoint_dv d-flex justify-content-between align-items-center'>
                                <div class='boardpoint_station'>
                                    <p>Boardpoint</p>
                                    <h5>${Boardpoint || ''}</h5>
                                </div>`;
                    if (element.type === 'Truck') {
                        htmlContent += `
                                    <div class='flight_details'>
                                        <p class='flign_no_tym'><span>DEP:</span> ${element.booking_truck_date_detail?.departure_date + " " + formatTime(element.booking_truck_date_detail?.departure_time) || ''}</p>
                                        <img src='${CargoTruck} alt='cargo_truck'/>
                                        <p class='flign_no_tym'><span>ARR:</span>   ${element.booking_truck_date_detail?.arrival_date + " " + formatTime(element.booking_truck_date_detail?.arrival_time) || ''}</p>
                                    </div>`;

                    } else if (element.type === 'Flight') {
                        htmlContent += `
                                    <div class='flight_details'>
                                        <p class='flign_no_tym'> <span>DEP:</span> ${element.flight_schedule?.departure_date_utc || ''}</p>
                                        <img src='${BlueFlight}'  class="blueflight" alt='blue_flight'/>
                                        <p class='flign_no_tym'> <span>ARR:</span> ${element.flight_schedule?.arrival_date_utc || ''}</p>
                                    </div>`;
                        Offpoint = element.flight_schedule?.destination;
                    }

                    htmlContent += `
                                <div class='offpoint_station'>
                                    <p>Offpoint</p>
                                    <h5>${Offpoint || ''}</h5>
                                </div>
                            </div>
                        </div>`
                });
            }
        } else {
            htmlContent += "<span>No Data Is Available For This AWB</span>";
        }
        let tooltipHtml = "<div class='pallet_hv route_shipment_segment_dv'>";
        if (movements.length > 0) {
            tooltipHtml += "<h5><span>" + data.airway_bill + " -</span> <span>Route Shipment</span></h5>";
        }
        tooltipHtml += htmlContent;
        tooltipHtml += "</div>";
        return tooltipHtml;

    }

    const formatMinutesToHHMM = (minutes) => {
        const hrs = Math.floor(minutes / 60);
        const mins = Math.floor(minutes % 60);
        return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    };


    // Delegated handlers - call this once after grid init
    // function attachDelegatedTooltipHandlers() {
    //     const $grid = window.$(gridRef.current);
    //     if (!$grid || !$grid.length) return;
    //     ensureTooltipDiv();
    //     $grid.off('mouseenter.customTooltip', '.row_info');
    //     $grid.off('mousemove.customTooltip', '.row_info');
    //     $grid.off('mouseleave.customTooltip', '.row_info');
    //     $grid.on('mouseenter.customTooltip', '.row_info', function (e) {
    //         const $el = window.$(this);
    //         const rowDiv = $el.closest('[role="row"]');
    //         const rowIndex = rowDiv.attr('row-id');
    //         let data = null;
    //         try {
    //             data = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex) || {};
    //         } catch (err) {
    //             data = {};
    //         }
    //         const html = buildTooltipHtml(data);
    //         $customTooltip.html(html).show();
    //         const pageX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || 0;
    //         const pageY = e.pageY || (e.originalEvent && e.originalEvent.pageY) || 0;
    //         const tooltipWidth = $customTooltip.outerWidth();
    //         const tooltipHeight = $customTooltip.outerHeight();
    //         const windowWidth = window.innerWidth;
    //         const windowHeight = window.innerHeight;
    //         const scrollTop = window.scrollY || document.documentElement.scrollTop;
    //         const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    //         let left = pageX + 16;
    //         let top = pageY + 16;
    //         if (left + tooltipWidth > windowWidth + scrollLeft) {
    //             left = pageX - tooltipWidth - 16;
    //             if (left < scrollLeft + 8) left = scrollLeft + 8; // clamp to viewport
    //         }
    //         const spaceBelow = windowHeight + scrollTop - (pageY + 16);
    //         const spaceAbove = pageY - scrollTop - 16;
    //         if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
    //             top = pageY - tooltipHeight - 16;
    //         }
    //         if (top < scrollTop + 8) {
    //             top = scrollTop + 8;
    //         }
    //         if (top + tooltipHeight > windowHeight + scrollTop) {
    //             top = windowHeight + scrollTop - tooltipHeight - 8;
    //         }
    //         $customTooltip.css({
    //             left: left + 'px',
    //             top: top + 'px'
    //         });
    //     });
    //     $grid.on('mousemove.customTooltip', '.row_info', function (e) {
    //         if (!$customTooltip) return;
    //         const pageX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || 0;
    //         const pageY = e.pageY || (e.originalEvent && e.originalEvent.pageY) || 0;
    //         const tooltipWidth = $customTooltip.outerWidth();
    //         const tooltipHeight = $customTooltip.outerHeight();
    //         const windowWidth = window.innerWidth;
    //         const windowHeight = window.innerHeight;
    //         const scrollTop = window.scrollY || document.documentElement.scrollTop;
    //         const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    //         let left = pageX + 16;
    //         let top = pageY + 16;
    //         if (left + tooltipWidth > windowWidth + scrollLeft) {
    //             left = pageX - tooltipWidth - 16;
    //             if (left < scrollLeft + 8) left = scrollLeft + 8; // clamp to viewport
    //         }
    //         const spaceBelow = windowHeight + scrollTop - (pageY + 16);
    //         const spaceAbove = pageY - scrollTop - 16;
    //         if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
    //             top = pageY - tooltipHeight - 16;
    //         }
    //         if (top < scrollTop + 8) {
    //             top = scrollTop + 8;
    //         }
    //         if (top + tooltipHeight > windowHeight + scrollTop) {
    //             top = windowHeight + scrollTop - tooltipHeight - 8;
    //         }
    //         $customTooltip.css({
    //             left: left + 'px',
    //             top: top + 'px'
    //         });
    //     });
    //     $grid.on('mouseleave.customTooltip', '.row_info', function () {
    //         if ($customTooltip) $customTooltip.hide();
    //     });
    //     $grid.off('scroll.customTooltip').on('scroll.customTooltip', function () {
    //         if ($customTooltip) $customTooltip.hide();
    //     });
    // }
    function attachDelegatedTooltipHandlers() {
        const $grid = window.$(gridRef.current);
        if (!$grid || !$grid.length) return;

        ensureTooltipDiv();

        let tooltipHover = false;
        let cellHover = false;

        // Handle hover events on the tooltip itself
        $customTooltip
            .off('mouseenter.tooltipHover mouseleave.tooltipHover')
            .on('mouseenter.tooltipHover', function () {
                tooltipHover = true;
            })
            .on('mouseleave.tooltipHover', function () {
                tooltipHover = false;
                if (!cellHover) $customTooltip.hide();
            });

        // Remove old handlers to prevent duplicates
        $grid.off('mouseenter.customTooltip mousemove.customTooltip mouseleave.customTooltip scroll.customTooltip');

        // Mouse enter on grid cell
        $grid.on('mouseenter.customTooltip', '.row_info', function (e) {
            cellHover = true;

            const $el = window.$(this);
            const rowDiv = $el.closest('[role="row"]');
            const rowIndex = rowDiv.attr('row-id');
            let data = null;

            try {
                data = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex) || {};
            } catch (err) {
                data = {};
            }

            const html = buildTooltipHtml(data);
            $customTooltip.html(html).show();

            positionTooltip(e);
        });

        // Mouse move to reposition tooltip dynamically
        $grid.on('mousemove.customTooltip', '.row_info', function (e) {
            positionTooltip(e);
        });

        // Mouse leave on grid cell
        $grid.on('mouseleave.customTooltip', '.row_info', function () {
            cellHover = false;
            setTimeout(() => {
                if (!tooltipHover) $customTooltip.hide();
            }, 150); // small delay to allow moving into tooltip
        });

        // Hide tooltip on grid scroll
        $grid.on('scroll.customTooltip', function () {
            if ($customTooltip) $customTooltip.hide();
        });

        // Helper function to handle tooltip positioning
        function positionTooltip(e) {
            const pageX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || 0;
            const pageY = e.pageY || (e.originalEvent && e.originalEvent.pageY) || 0;
            const tooltipWidth = $customTooltip.outerWidth();
            const tooltipHeight = $customTooltip.outerHeight();
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

            let left = pageX + 16;
            let top = pageY + 16;

            // Prevent tooltip from going off screen horizontally
            if (left + tooltipWidth > windowWidth + scrollLeft) {
                left = pageX - tooltipWidth - 16;
                if (left < scrollLeft + 8) left = scrollLeft + 8;
            }

            // Adjust vertical position (flip if not enough space below)
            const spaceBelow = windowHeight + scrollTop - (pageY + 16);
            const spaceAbove = pageY - scrollTop - 16;
            if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
                top = pageY - tooltipHeight - 16;
            }

            // Clamp top position within viewport
            if (top < scrollTop + 8) top = scrollTop + 8;
            if (top + tooltipHeight > windowHeight + scrollTop)
                top = windowHeight + scrollTop - tooltipHeight - 8;

            $customTooltip.css({
                left: left + 'px',
                top: top + 'px'
            });
        }
    }

    const handleModalClose = () => { setShowModal(false); setModalData(); };

    const handleModalOpen = (area, item) => {
        setNotArea(area);
        if (area === 'G') {
            setRowId(item);
        }
        setShowModal(true);

    };

    const handleConfirmation = (confirm) => {
        if (confirm) {
            if (notArea === 'G') {
                handleDeleteRow();
            } else if (notArea === 'F') {
                handleReFinalize()
            }
            setShowModal(false);
        } else {
            setModalData();
            setShowModal(false);
        }
    };

    const handleReFinalize = async () => {
        try {
            const res = await withRFSToken.post('booking-schedule-plan-status-change', { bookingtruck_date_id: selectedRowData.bookingtruck_date_id })
                .then(function (res) {
                    const innerData = res.data;
                    if (res.data.response_code === 200) {
                        toast.success(res.data.response_msg);
                        window.location.href = '/BookingtruckDetails/Planning'
                    } else {
                        toast.error(res.data.response_msg);
                    }

                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const handleDeleteRow = async () => {
        try {
            const res = await withRFSToken.post(DELAWB, { awb_id: rowId })
                .then(function (res) {
                    const innerData = res.data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code === 200) {
                        // fetchPalletList();
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRef.current).jqxGrid('updatebounddata');
                        }, 1);
                    }

                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const handleShow = (e, item) => {
        if (e == 'Assign') {
            if (gridSelect.length === 0) {
                toast.error('Please select at least one Airway Bill to reassign')
            } else {
                //setShow(true);
                getAvailableScheduleTruck();
                setReAssignShow(true);
                setAddEdit(e);
                setGridSelectData(gridSelect);
                const keysToRemove = ['Assign AWB'];
                keysToRemove.forEach(key => localStorage.removeItem(key));
                const storageData = { AWB: gridSelect, BTS: {} };
                localStorage.setItem(item, JSON.stringify(storageData));
            }
        } else {
            setShow(true);
            setAddEdit(e);
            setEditModalData(item);
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    const reAssignHandleClose = () => {
        setReAssignShow(false);
        setGridSelect([]);
        setGridSelectData([]);
        window.$(gridRef?.current).jqxGrid('clearselection');
    };

    const reloadGridData = () => {
        setTimeout(() => {
            setIsLoading(false);
            window.$(gridRef.current).jqxGrid('updatebounddata');
        }, 1);
    }

    const getToDeialsClick = (id, e) => {
        localStorage.removeItem('TODetails');
        const storageData = { truck_orders_id: id, tab: e };
        localStorage.setItem('TODetails', JSON.stringify(storageData));
        window.location.href = '/TruckOrderDetails'
    }

    const handleDeleteAwb = (index) => {
        setGridSelectData((prev) => prev.filter((_, i) => i !== index));
    };

    const handleTruckSelect = (bookingtruck_date_id, date) => {
        setSelectedTrucks({
            bookingtruck_date_id,
            date
        });
    };

    const handleReassign = async (conf) => {
        if (selectedTrucks.bookingtruck_date_id != '' && selectedTrucks.departure_date != '') {
            if (conf == "yes") {
                const updatedFormData = {
                    AWB: gridSelectData,
                    BTS: selectedTrucks,
                    action_confirm: "yes",
                    // action_confirm: conf ? conf : null,
                };
                try {
                    const res = await withRFSToken.post(ADDAWB, updatedFormData)
                        .then(function (res) {
                            const innerData = res.data.response_data;
                            if (res.data.response_code === 200 || res.data.response_code === 220) {
                                // setConfirmModal(true);
                                if (conf == "yes") {
                                    setConfirmModal(false);
                                    setReAssignShow(false);
                                    // setGridSelectData([]);
                                    setGridSelect([]);
                                    toast.success(res.data.response_msg);
                                    window.$(gridRef.current).jqxGrid('clearselection');
                                    window.$(gridRef.current).jqxGrid('refresh');
                                    window.$(gridRef.current).jqxGrid('updatebounddata');
                                    setSelectedTrucks({
                                        bookingtruck_date_id: '',
                                        departure_date: ''
                                    });
                                }
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            } else {
                setConfirmModal(true);
            }
        } else {
            toast.error('Please select a Truck to reassign the AWB(s)');
        }
    };

    const confirmModalClose = () => {
        setConfirmModal(false);
    }

    useEffect(() => {
        if (gridSelectData?.length == 0) {
            reAssignHandleClose();
        }
    }, [gridSelectData]);
    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');
    };

    const handleOrderTruckOrder = async (info) => {
        // console.log('info', info);
        localStorage.removeItem('OT');
        try {
            const res = await withRFSToken.post(TRUCKORDERDETAILS, { truck_orders_id: info.truck_orders_id })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        const innerData = res.data.response_data;
                        console.log('innerData', innerData);
                        const sendData = {
                            ...innerData,
                            truck_type: 'B',
                            // bookingTruck_type: selectedRowData.bookingTruck_type,
                            departure_date_time : innerData.departure_date + 'T' + innerData.departure_time,
                            arrival_date_time : innerData.arrival_date + 'T' + innerData.arrival_time,
                            existing_date: selectedRowData.date,
                            step: 1
                        }
                        localStorage.setItem('OT', JSON.stringify(sendData));
                        window.location.href = '/OrderTruck'
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };



    return (

        <div className="">
            <Loader isLoading={loaderModal} />
            <Header logo_url='/BookingtruckSchedule' />
            <div className="schedule">
                <LeftMenu />
                <div className='main-panel'>
                    <Link to={'/BookingtruckSchedule'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                    <div className='maindiv'>
                        <div className='SecondDiv mt-3'>
                            <div className='girddtals_header'>
                                <h3>
                                    {selectedRowData?.bookingtruck_no}
                                    <span className={
                                        selectedRowData?.status === 'Scheduled' ? 'bookingstatus scheduled mx-2 abslt'
                                            : (selectedRowData?.status === 'To be Planned' ? 'bookingstatus tbplanned mx-2 abslt'
                                                : (selectedRowData?.status === 'Planning in Progress') ? 'bookingstatus pprogress mx-2 abslt'
                                                    : ((selectedRowData?.status === 'Planning Finalized' ? 'bookingstatus pfinalized mx-2 abslt'
                                                        : 'bookingstatus')))
                                    }>
                                        {selectedRowData?.status}
                                    </span>


                                </h3>
                                <div className='d-flex actbtn justify-content-between'>
                                    <div className='d-flex'>
                                        <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                        {/* <Dropdown>
                                            <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                <FontAwesomeIcon icon={faBolt} /> Action
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item >Edit Bookingtruck</Dropdown.Item>
                                                <Dropdown.Item href="#/action-2">Manage Shipments</Dropdown.Item>
                                                <Dropdown.Item href="/TruckOrder">Order Truck</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> */}
                                    </div>
                                    <div className='viwall'>
                                        {/* <Link to='/BookingtruckDetails'>View Details</Link> */}
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between rabord'>
                                <div className='firstbrd'>
                                    <p>Boardpoint</p>
                                    <span>{selectedRowData?.boardpoint}</span>
                                </div>
                                <div className='middlebrd'>
                                    <span style={{ fontSize: '14px' }}><b>DEP : </b>{selectedRowData?.departure_date} {selectedRowData?.departure_time}</span>
                                    <p><img src={Cargotruck} /></p>
                                    <span style={{ fontSize: '14px' }}><b>ARR : </b>{selectedRowData?.arrival_date} {selectedRowData?.arrival_time}</span>
                                </div>
                                <div className='lastbrd'>
                                    <p>Offpoint</p>
                                    <span>{selectedRowData?.offpoint}</span>
                                </div>
                            </div>
                            <div>
                                <h3>Operational Trucks</h3>
                                {selectedRowData && selectedRowData.operational_trucks.map((truck) => (
                                    <div key={truck.truck_id} className='d-flex justify-content-between align-items-center opt_truck'>
                                        {/* {console.log("🚀 ~ ExportActive ~ truck:", truck)} */}
                                        <div>
                                            <span>Truck No</span>
                                            <h4>{truck.truck_no}</h4>
                                        </div>
                                        {/* <div className={truck.request_status == 'O' ? 'offer_reecv' : (truck.request_status == 'B' ? 'booked' : 'offer_rqst')}>
                                            <span>{truck.request_status == 'O' ? 'Offer Received' : (truck.request_status == 'B' ? 'Booked' : 'Requested')}</span>
                                        </div> */}
                                        <div className={truck.status == 'Offer Received' ? 'offer_reecv' : (truck.status == 'Booked' ? 'booked' : 'offer_rqst')}>
                                            <span>{truck.status}</span>
                                        </div>
                                        <div>
                                            {/* <Link to='#' onClick={() => getToDeialsClick(truck.truck_orders_id, 'shipment')}>Details</Link> */}
                                            {truck.status === 'Draft' ? (
                                                truck.status === 'Draft' && (
                                                    <Link to='#' onClick={() => handleOrderTruckOrder(truck)}>Order</Link>
                                                )
                                            ) : (
                                                <Link to='#' onClick={() => getToDeialsClick(truck.truck_orders_id, 'shipment')}>
                                                    Details
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <ImageUpload
                                ref={imageUploadRef}
                                attachable_type={"booking_schedule_date"}
                                attachable_id={selectedRowData?.bookingtruck_date_id}
                                attachments={selectedRowData?.attachments}
                                galleryViewId={selectedRowData?.bookingtruck_no}
                                onDeleteSuccess={() => loadDetails(selectedRowData?.bookingtruck_id, selectedRowData?.bookingtruck_date_id)}
                                attachment_no={selectedRowData?.bookingtruck_no + ' / ' + selectedRowData?.departure_date}
                            />
                            <div>
                                <ActivityComments
                                    commentable_type={"booking_schedule_date"}
                                    commentable_id={selectedRowData?.bookingtruck_date_id}
                                    allactivities={selectedRowData?.activities}
                                    onReloadDetails={() => loadDetails(selectedRowData?.bookingtruck_id, selectedRowData?.bookingtruck_date_id)}
                                />
                            </div>
                        </div>
                        <div className='trashdonload mt-3'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex'>
                                    <div className='me-3'>
                                        <button className="planing_btn" variant="primary" onClick={() => { selectedRowData?.status === 'Planning Finalized' ? handleModalOpen('F') : window.location.href = '/BookingtruckDetails/Planning' }}>
                                            <span> <img src={Planing} /> Planning</span>
                                        </button>
                                    </div>
                                    <div className='me-3'>
                                        <button className="addtruck" variant="primary" onClick={() => handleShow('A', '')}>
                                            <span> <FontAwesomeIcon icon={faPlus} /> Add Airway Bill</span>
                                        </button>
                                    </div>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handleShow('Assign', 'Assign AWB')}> Reassign </Dropdown.Item>
                                            <Dropdown.Item onClick={orderTruckRedirect}> Order Truck</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className='bkd_ttv'>
                                    <span className="me-2">Total Volume: {allData?.total_volume}</span>
                                    <span>Total Weight: {allData?.total_weight}</span>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='mvownload'></div>
                            </div>
                            <div className='mt-3 position-relative'>
                                {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                                {!isLoading && <>
                                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                    <div ref={gridRef} className='bookinggrid' ></div>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} centered className='addfrom awb_modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {addEdit === 'A' ?
                        <AddAWB
                            isModal={true}
                            closeModal={handleClose}
                            assignData={selectedRowData}
                            reloadGrid={reloadGridData}
                        />
                        : addEdit === 'E' ?
                            <AddAWB
                                isModalEdit={true}
                                closeModal={handleClose}
                                assignData={editmodalData}
                                reloadGrid={reloadGridData}
                            />

                            :
                            <AssignAWB
                                isModal={true}
                                closeModal={handleClose}
                                // assignData={editmodalData}
                                reloadGrid={reloadGridData}
                            />
                    }

                </Modal.Body>
            </Modal>
            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{notArea == 'F' ? 'Finalize Planning' : 'All changes will be destroyed.'}</h3>
                    <p>{notArea == 'F' ?
                        `Bookingtruck ${selectedRowData.bookingtruck_no} has already been finalized. Do you want to reopen the planning to make changes? This will move the status back to 'Planning in Progress'`
                        :
                        'If you proceed with the change, all data in this section will be removed. Are you sure you want to continue?'}</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-75 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                            {notArea == 'F' ? 'Cancel' : 'No'}
                        </Button>
                        <Button variant="primary" onClick={() => handleConfirmation(true)}>
                            {notArea == 'F' ? 'Reopen Planning' : 'Yes'}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={reAssignShow} onHide={reAssignHandleClose} centered className='addfrom awb_readdign_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Reassign AWB</Modal.Title>
                    <p>Reassign AWB [{gridSelectData?.map(item => item.airway_bill).join(', ') || ''}] to a new Scheduled Truck.</p>
                </Modal.Header>
                <Modal.Body>
                    <ul class="px-0">
                        {gridSelectData?.map((item, i) => (
                            <div className="awb_reassign_list">
                                <div className="awb_reassign_crd d-flex justify-content-between align-items-center">
                                    <div className="awb_no_dv">
                                        <h6>AWB No.</h6>
                                        <p>{item.airway_bill}</p>
                                    </div>
                                    <div className="awb_volume">
                                        <h6>Volume</h6>
                                        <p>{item.volume ?? '-'}</p>
                                    </div>
                                    <div className="pieces">
                                        <h6>Pieces</h6>
                                        <p className="piece_txt"><img src={Box} alt="pieces" /><span className="ms-2">{item.pieces ?? ''}/{item.weight ?? ''}</span></p>
                                    </div>
                                    <div>
                                        <img
                                            src={TrashRed}
                                            alt="trash_icon"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleDeleteAwb(i)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="awb_reassign_crd">
                            {availableScheduleTruck?.map((availableScheduleTruckItem, i) => (
                                <div className='booking_boardpoint_wrap mb-3'>
                                    <div className="booking_no_dv d-flex align-items-center justify-content-between">
                                        <Form>
                                            <Form.Check
                                                type="radio"
                                                name="availableScheduleTruckItem"
                                                label={availableScheduleTruckItem?.bookingtruck_no}
                                                value={availableScheduleTruckItem?.bookingtruck_date_id}
                                                onChange={(e) =>
                                                    handleTruckSelect(
                                                        String(e.target.value),
                                                        availableScheduleTruckItem.departure_date
                                                    )
                                                }
                                                checked={
                                                    String(selectedTrucks?.bookingtruck_date_id) ===
                                                    String(availableScheduleTruckItem?.bookingtruck_date_id)
                                                }
                                            />
                                        </Form>
                                        <h6>{availableScheduleTruckItem.departure_date}</h6>
                                    </div>
                                    <div class="Boardpoint_offpoint_dv d-flex justify-content-between align-items-end">
                                        <div class="boardpoint_station">
                                            <p>Boardpoint</p>
                                            <h5>{availableScheduleTruckItem.board_point}</h5>
                                        </div>
                                        <div class="middlebrd">
                                            <p className="text-center">
                                                <img
                                                    src={CargoTruck}
                                                    alt="blue_flight"
                                                    className='blue_fligh_img'
                                                />
                                            </p>
                                            {/* <p className='connection_tym'>Connection Time: 12:00</p> */}
                                        </div>
                                        <div class="offpoint_station">
                                            <p>Offpoint</p>
                                            <h5>{availableScheduleTruckItem.off_point}</h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className='cancel_btn'>Cancel</Button>
                    <Button variant="primary" className='reassign_btn' onClick={() => handleReassign()}>Reassign</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={confirmModal} onHide={confirmModalClose} className='raintrac' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>Reassign Shipments</h2>
                    <p>
                        Are you sure you want to reassign these shipments to the selected booking truck?
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setConfirmModal(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={() => handleReassign("yes")}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Details;